<template>
  <div class="mypage-container">
    <mypage-header></mypage-header>
    <div id="container" v-loading="onSubmit" class="content-wrap">
      <div class="title-area01">
        <h2 class="h2-title01">회원탈퇴신청</h2>
        <p class="text-type01">
          FLYBIT 서비스를 이용해 주셔서 감사합니다. 더욱더 개선하여 좋은
          서비스와 품질로 보답하겠습니다.
        </p>
      </div>

      <!-- member-leave -->
      <el-form
        ref="leaveForm"
        status-icon
        class="member-leave"
        :model="leaveForm"
        :rules="rules"
      >
        <p class="title">{{ $t("leave.info.title") }}</p>
        <div class="box">
          <p class="txt01 sub">
            {{ $t("leave.info.description") }}
          </p>
          <ul class="list01">
            <li>
              <p class="tit">{{ $t("leave.info.delete.title") }}</p>
              <ul>
                <li>
                  {{ $t("leave.info.delete.content[0].title") }}
                  <ul>
                    <li class="sub margin4">
                      {{ $t("leave.info.delete.content[0].data[0]") }}
                    </li>
                  </ul>
                </li>
                <li class="margin20">
                  {{ $t("leave.info.delete.content[1].title") }}
                  <ul>
                    <li class="sub">
                      {{ $t("leave.info.delete.content[1].data[0]") }}
                    </li>
                    <li class="sub">
                      {{ $t("leave.info.delete.content[1].data[1]") }}
                    </li>
                    <li class="sub">
                      {{ $t("leave.info.delete.content[1].data[2]") }}
                    </li>
                    <li class="sub">
                      {{ $t("leave.info.delete.content[1].data[3]") }}
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <p class="tit">{{ $t("leave.info.disappearance.title") }}</p>
              <ul>
                <li>
                  {{ $t("leave.info.disappearance.content[0].title") }}
                  <ul>
                    <li class="sub">
                      {{ $t("leave.info.disappearance.content[0].data[0]") }}
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <p class="title">{{ $t("leave.reason.reason.title") }}</p>
        <div class="box">
          <div class="form">
            <div>
              <p class="sub">
                {{ $t("leave.reason.reason.notice") }}
              </p>
              <div class="cause">
                <div
                  v-for="(item, index) in leaveForm.cause"
                  :class="{ active: item.isActive }"
                  @click="item.isActive = !item.isActive"
                  :key="index"
                  class="cause-item"
                >
                  {{ item.txt }}
                </div>
              </div>
            </div>
            <div class="opinion">
              <p class="tit text-area">
                {{ $t("leave.reason.reason.improvement") }}
              </p>
              <div class="write">
                <el-form-item prop="desc">
                  <el-input
                    type="textarea"
                    maxlength="32"
                    v-model="leaveForm.desc"
                    :autosize="{ minRows: 4, maxRows: 8 }"
                    :max="500"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>

        <div class="text01">
          <el-form-item prop="check">
            <el-checkbox
              v-model="leaveForm.check"
              name="check"
              class="block-type01"
            >
              <span class="text01">
                {{ $t("leave.withdrawMembership") }}
              </span>
            </el-checkbox>
          </el-form-item>
        </div>
      </el-form>
      <!--// member-leave -->

      <div class="btn-type01">
        <router-link
          :to="{ name: 'mypage' }"
          class="leave btn-large01 btn-style-gray"
          style="width: 214px;"
          >{{ $t("confirm.cancel") }}</router-link
        >
        <a
          href="#confirm"
          class="leave btn-large01 btn-style-blue"
          style="width: 214px;"
          @click.prevent="submit"
          >{{ $t("confirm.ok") }}</a
        >
      </div>

      <el-dialog
        :title="$t('leave.title.check')"
        :visible.sync="modal1"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        v-loading="modal1Submit"
        class="modal-type01 leave-modal"
        width="90%"
        center
      >
        <div class="text-center">
          <p
            class="text-type01 mgb25"
            v-html="$t('leave.popup.confirm[0]')"
          ></p>
          <p class="text-type02">
            <strong class="txt-blue">
              {{ $t("leave.popup.confirm[1]") }}
            </strong>
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button
            href=""
            class="leave btn-style01 btn-style-gray"
            @click.prevent="modal1 = false"
            >{{ $t("confirm.cancel") }}</el-button
          >
          <el-button
            href="/"
            class="leave btn-style01 btn-style-blue"
            @click.prevent="leaveCommit"
            >{{ $t("confirm.ok") }}</el-button
          >
        </div>
      </el-dialog>

      <el-dialog
        title="회원탈퇴 불가 안내"
        :visible.sync="modal2"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="modal-type01 leave-modal"
        width="90%"
        center
      >
        <div class="text-center">
          <p class="text-type01 mgb25">
            [탈퇴불가 사유 : KRW 잔고, 암호화폐 잔고, <br />
            진행 중인 거래내역]를(을) 확인해 주세요.
          </p>
          <p class="text-type01 text-left mgb15">
            {{ $t("leave.popup.reject.title") }}
          </p>
          <p class="txt01 text-left">
            - {{ $t("leave.popup.reject.data[0]") }}<br />
            - {{ $t("leave.popup.reject.data[1]") }}<br />
            - {{ $t("leave.popup.reject.data[2]") }}
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <a
            href=""
            class="btn-style01 btn-style-blue"
            @click.prevent="modal2 = false"
            >{{ $t("confirm.ok") }}</a
          >
        </span>
      </el-dialog>

      <el-dialog
        :title="$t('leave.title.complete')"
        :visible.sync="leaveConfirmModal"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="modal-type01 leave-modal"
        width="90%"
        center
      >
        <div class="text-center">
          <p class="text-type02">
            {{ $t("leave.popup.adminCheck") }}
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <a
            href=""
            class="leave-complete btn-style01 btn-style-blue"
            @click.prevent="leaveAppConfirm"
            >{{ $t("confirm.ok") }}</a
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import MypageHeader from "./component/mypage/header.vue";
import { mapGetters } from "vuex";
import Api from "@/common/Api";

export default {
  components: {
    MypageHeader,
  },
  data() {
    return {
      modal1: false,
      modal1Submit: false,
      modal2: false,
      onSubmit: false,
      leaveConfirm: false,
      leaveCheck: false,
      leaveConfirmModal: false,
      leaveForm: {
        cause: [
          {
            txt: this.$t("leave.reason.reason.button[0]"),
            isActive: false,
          },
          {
            txt: this.$t("leave.reason.reason.button[1]"),
            isActive: false,
          },
          {
            txt: this.$t("leave.reason.reason.button[2]"),
            isActive: false,
          },
          {
            txt: this.$t("leave.reason.reason.button[3]"),
            isActive: false,
          },
          {
            txt: this.$t("leave.reason.reason.button[4]"),
            isActive: false,
          },
          {
            txt: this.$t("leave.reason.reason.button[5]"),
            isActive: false,
          },
        ],
        desc: "",
        check: false,
      },
      rules: {
        cause: [
          {
            validator: this.isCheck,
            message: this.$t("notice.content.selectReason"),

            trigger: "blur change",
          },
        ],
        desc: [
          {
            min: 0,
            max: 500,
            message: this.$t("notice.content.textExceeded"),
            trigger: "blur",
          },
        ],
        // check: [
        //   {
        //     validator: this.isAgree,
        //     message: this.$t("leave.error.agree"),
        //     trigger: "change",
        //   },
        // ],
      },
    };
  },
  computed: {
    ...mapGetters(["isLogin"]),
    reasons() {
      const reasons = [
        ..._.chain(this.leaveForm.cause)
          .filter("isActive")
          .map("txt")
          .value(),
      ];
      if (this.leaveForm.desc) {
        reasons.push(this.leaveForm.desc);
      }
      return reasons;
    },
  },
  created() {},
  methods: {
    isCheck(rule, value, callback) {
      let causeCheck = this.leaveForm.cause;
      let chx = causeCheck.some((blooan) => blooan.isActive);
      if (chx) {
        callback();
      } else {
        callback(this.$t("leave.error.enterReason"));
      }
    },
    isAgree(rule, value, callback) {
      if (this.leaveForm.check) {
        callback();
      } else {
        callback(new Error(this.$t("leave.error.agree")));
      }
    },
    submit() {
      if (this.onSubmit) {
        return false;
      }

      const leaveForm = this.$refs.leaveForm;

      // 사유 확인
      if (!this.reasons.length) {
        this.$msgbox({
          message: this.$t("leave.error.selectReason"),
          showClose: false,
        });
        return false;
      }
      if (!this.leaveForm.check) {
        this.$msgbox({
          message: this.$t("leave.error.agree"),
          showClose: false,
        });
        return false;
      }

      this.leaveConfirm = true;
      this.modal1 = true;
    },
    leaveCommit() {
      Api.User.leave(this.reasons.join(", "))
        .then((response) => {
          // this.$notify.info({
          //   duration: 3000,
          //   title: '회원탈퇴 신청이 완료',
          //   message: 'FLYBIT 운영자의 ‘승인’ 절차에 의해 탈퇴 처리가 진행되며, 정상적으로 탈퇴 처리 완료 시 회원님의 휴대폰번호와 이메일 주소로 안내 메시지를 발송해 드립니다.'
          // });
          this.modal1 = false;
          this.leaveConfirmModal = true;
        })
        .catch((e) => {
          this.$notify({
            duration: 3000,
            title: this.$t("leave.title.fail"),
            type: "warning",
            message: e.msg,
            customClass: "dexko-noti",
            position: "top-left",
          });
          this.$router.back();
        });
    },
    leaveAppConfirm() {
      this.leaveConfirmModal = false;
      this.$store.dispatch("logOut");
      this.$router.replace("/");
    },
  },
};
</script>
<style lang="scss" scoped>
.content-wrap {
  padding: 20px 12px 40px;
  color: #000;
  p {
    margin-bottom: 0;
  }
  .title-area01 {
    padding-bottom: 12px;
    .h2-title01 {
      font-size: 15px;
      font-weight: 500;
      color: #000;
    }
    .text-type01 {
      margin-top: 8px;
      font-size: 13px;
      font-weight: normal;
      color: #838a92;
    }
  }
  .member-leave {
    font-size: 13px;
    p.title {
      padding: 8px 6px;
      font-weight: 500;
      color: #000;
      border-top: 2px solid #333;
      border-bottom: 1px solid #d0d5da;
      background-color: #f7f7f7;
    }
    .box {
      padding-bottom: 20px;
      .txt01 {
        margin-bottom: 20px;
        color: #838a92;
      }
      .list01 {
        .tit {
          margin: 20px 0 8px;
        }
      }
      .sub {
        margin-top: 8px;
        color: #838a92;
        &.margin4 {
          margin-top: 4px;
        }
        &.txt01 {
          margin-top: 12px;
        }
      }
      .cause {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-bottom: 20px;
        font-size: 12px;
        &-item {
          width: calc((100% - 8px) / 2);
          margin: 8px 8px 0 0;
          padding: 11px 0;
          text-align: center;
          border: 2px solid #d0d5da;
          &:nth-child(2n) {
            margin-right: 0;
          }
          &.active {
            font-weight: 700;
            color: #0056b6;
            border-color: #0056b6;
          }
        }
      }
      .opinion {
        .tit.text-area {
          margin-bottom: 8px;
          font-weight: 500;
        }
      }
    }
    .margin20 {
      margin-top: 20px;
    }
    .el {
      &-checkbox {
        display: flex;
        white-space: inherit;
        font-weight: normal;
        color: #000;
      }
      &__input {
        vertical-align: super;
      }
      &__label {
        display: block;
        width: 90%;
        font-size: 13px;
      }
      &-item__content {
        font-size: 12px;
      }
    }
  }
}
.dialog-footer {
  display: flex;
}
</style>
